import { render } from "./SaveSearch.vue?vue&type=template&id=0a34ee84&ts=true"
import script from "./SaveSearch.vue?vue&type=script&lang=ts"
export * from "./SaveSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/crud/infrastructure/search/SaveSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a34ee84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a34ee84', __exports__)) {
    api.reload('0a34ee84', __exports__)
  }
  
  module.hot.accept("./SaveSearch.vue?vue&type=template&id=0a34ee84&ts=true", () => {
    api.rerender('0a34ee84', render)
  })

}


export default __exports__